export default "__VITE_ASSET__BqfcZ1eo__"